import script from "./Popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popover.vue?vue&type=script&setup=true&lang=ts"

import "./Popover.vue?vue&type=style&index=0&id=6d75affe&lang=css"
import "./Popover.vue?vue&type=style&index=1&id=6d75affe&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d75affe"]])

export default __exports__